module.exports = __webpack_public_path__ + "img/sr.b5c98425.png";